import { memo, ReactNode } from 'react';
import { Typography } from 'antd';
import styles from './Title.module.css';

interface TitleProps {
  children: ReactNode;
  className?: string;
  level: 1 | 2 | 3 | 4 | 5;
}

function Title({ children, className, level }: TitleProps) {
  let levelClassName = undefined;
  switch (level) {
    case 1:
      levelClassName = styles.h1;
      break;
    case 2:
      levelClassName = styles.h2;
      break;
    case 3:
      levelClassName = styles.h3;
      break;
    case 4:
      levelClassName = styles.h4;
      break;
    case 5:
      levelClassName = styles.h5;
      break;
    default:
      levelClassName = undefined;
  }

  return (
    <Typography.Title className={`${className} ${levelClassName}`} level={1}>
      {children}
    </Typography.Title>
  );
}

export default memo(Title);
